module.exports = __webpack_public_path__ + "static/img/third1_6.ce70f428.png";